import React from 'react';
import { Box, Typography } from '@mui/material';
import InboxIcon from '@mui/icons-material/Inbox';

interface NoDataStateProps {
  title?: string;
  message?: string;
  height?: string | number;
  width?: string | number;
  showBackground?: boolean;
}

export const NoDataState: React.FC<NoDataStateProps> = ({
  title = 'No data available',
  message = 'There is no data to display for the selected criteria.',
  height = '200px',
  width = '100%',
  showBackground = true,
}) => {
  return (
    <Box
      sx={{
        height,
        width,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 2,
        background: showBackground ? '#f9fafb' : 'transparent',
        borderRadius: showBackground ? '8px' : '0',
        border: showBackground ? '1px solid #e5e7eb' : 'none',
        padding: 3,
      }}
    >
      <InboxIcon 
        sx={{ 
          fontSize: 48, 
          color: '#9ca3af',
          opacity: 0.7,
        }} 
      />
      <Box sx={{ textAlign: 'center' }}>
        <Typography
          variant="h6"
          sx={{
            color: '#374151',
            fontSize: '16px',
            fontWeight: 600,
            marginBottom: 1,
          }}
        >
          {title}
        </Typography>
        <Typography
          variant="body2"
          sx={{
            color: '#6b7280',
            fontSize: '14px',
            lineHeight: 1.5,
            maxWidth: '400px',
          }}
        >
          {message}
        </Typography>
      </Box>
    </Box>
  );
}; 